import gettext from '@sdk/lang/gettext';
import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';

import { MessagePost } from '@web/conversations/types/Message';

import { useRetrySend } from './retrySendButton.hooks';
import { Button, RetryIcon } from './retrySendButton.styles';

type Props = {
  message: MessagePost;
};

export const RetrySendButton = ({ message }: Props) => {
  const retrySend = useRetrySend(message);

  return (
    <SmartTooltip content={gettext('Resend')}>
      <Button onClick={retrySend}>
        <RetryIcon />
      </Button>
    </SmartTooltip>
  );
};
